import React from 'react';
import { ToolkitFeatureFlag } from '@cko/primitives';
import { getMenuItemTestId } from 'utils/getMenuItemTestId';
import { LabelContainer, StyledStatus } from './SideNavMenu.styles';

interface SideNavLabelProps {
  label: string;
  statusLabel?: string;
}

export const SideNavLabel = (props: SideNavLabelProps) => {
  const { label, statusLabel } = props;
  const sideNavMenuItemTestId = getMenuItemTestId('side-nav', label);

  return (
    <LabelContainer data-testid={sideNavMenuItemTestId}>
      {label}
      {statusLabel && (
        <ToolkitFeatureFlag flag="v10">
          <StyledStatus variant="highlight">{statusLabel}</StyledStatus>
        </ToolkitFeatureFlag>
      )}
    </LabelContainer>
  );
};
